<div appearance="fill">
    <div class="input-wrapper">
        <input #input matInput type="text" class="ag-input" [formControl]="myControl" [placeholder]="placeholder"
            [matAutocomplete]="auto" (focus)="onFocus($event)" (blur)="onBlur()" (keydown.enter)="onBlur()" [style.width.px]="cellWidth"
            [style.height.px]="cellHeight" data-testid="autocomplete-input">
        <mat-icon class="clear-icon" (click)="clearInput($event)" (keydown.enter)="clearInput($event)" aria-label="Clear input" data-testid="autocomplete-clear-icon">close</mat-icon>
        <mat-icon class="arrow-icon" (click)="togglePanel()" (keydown.enter)="togglePanel()" data-testid="autocomplete-dropdown-arrow">{{ isPanelOpen ?
            'keyboard_arrow_up' :
            'keyboard_arrow_down' }}</mat-icon>

        <mat-autocomplete #auto="matAutocomplete" [panelWidth]="panelWidth" (opened)="onPanelOpen()"
            (closed)="onPanelClose()" class="custom-autocomplete">
            <div (mousedown)="$event.stopPropagation()" class="options-container">
                @if(loader()){
                <mat-option class="loader-option" data-testid="autocomplete-loader">
                    <div class="center">
                        <mat-spinner diameter="20"></mat-spinner>
                    </div>
                </mat-option>
                }
                @for (option of filteredOptions | async; track option.value; let i = $index) {
                @if (option) {
                <mat-option (mousedown)="selectOption(option)" [value]="option"
                    [ngClass]="{'selected-option': option.value.toLowerCase() === controlValueAsString?.toLowerCase()}"
                    [attr.data-testid]="'autocomplete-option-' + i">{{ option.displayValue ?? option.value }}</mat-option>
                }
                }
            </div>
        </mat-autocomplete>

    </div>
</div>